<template>
	<div class="cyBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" @qrsFn="subFn" @callFn="fxFlag = false" :title="`您正在获取班级课本`">
			<p class="fxP">请选择需要获取的课本</p>
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="60px">
				<el-form-item label="课 本" prop="textbookId">
					<el-select style="width: 100%" v-model="ruleForm.textbookId" filterable allow-create default-first-option placeholder="请选择课本">
						<el-option v-for="(item, index) in perData" :key="index" :label="item.title" :value="item.textbookId"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<dialogBox :dialogFlag="delFlag" rigTxt="确认删除" rigBg="#D33931" @callFn="delFlag = false" :title="''">
			<div class="delBox">
				<img src="@/assets/img/sc (6).png" alt="" />
				<h2>删除试卷后将无法恢复</h2>
				<p>是否确定删除</p>
			</div>
		</dialogBox>
		<div class="cyTop">
			<div class="cyDelBtn cyDelBtns" @click="fxFlag = true">
				<img src="@/assets/img/编组 (12).png" alt="" />
				获取课本
			</div>
			<div class="cyDelBtn" @click="delQbFn">
				<img src="@/assets/img/编组 (11).svg" alt="" />
				全部删除
			</div>
		</div>
		<div class="cyCont">
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" header-row-class-name="btClass" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" align="center" prop="status" :selectable="checkSelectable" width="80"></el-table-column>
				<el-table-column align="center" prop="name" label="封面">
					<template slot-scope="scope">
						<el-image class="imgs ispan" @click="kbenBtn(scope.row)" :src="$imgUrl + scope.row.coverImg" lazy></el-image>
					</template>
				</el-table-column>
				<el-table-column align="center" label="书名">
					<template slot-scope="scope">
						<span class="ispan" @click="kbenBtn(scope.row)">{{ scope.row.title }}</span>
					</template>
				</el-table-column>
				<el-table-column label="报告" align="center">
					<template slot-scope="scope">
						<div class="keBox">
							<div style="color: #1d7b3a; font-size: 14px; margin-right: 10px" @click="decFn(scope.row)">
								<div class="iconBox">
									<img src="@/assets/img/形状 (1).png" class="ztIcon" alt="" />
									做题详情
								</div>
							</div>
							<div style="color: #fa4a1b; font-size: 14px" @click="ctFn(scope.row)">
								<div class="iconBox">
									<img src="@/assets/img/ctfb.svg" class="ztIcon" alt="" />
									错题分布
								</div>
							</div>
							<div class="reportEntry" @click="reportFn(scope.row)">
								<div class="iconBox">
									<i class="el-icon-data-analysis"></i>
									答题报告
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';

export default {
	name: 'keBen',
	data() {
		return {
			tableData: [],
			perData: [],
			ruleForm: {
				textbookId: ''
			},
			rules: {
				textbookId: [{ required: true, message: '请选择课本', trigger: 'change' }]
			},
			fullscreenLoading: false,
			delFlag: false,
			fxFlag: false,
			options: [],
			tabFlag: 1,
			multipleSelection: []
		};
	},
	props: ['bjId', 'a'],
	components: {
		dialogBox
	},
	methods: {
		subFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					console.log(8888);
					let { textbookId } = this.ruleForm;
					let set = this.$loading(this.$pre);
					this.$http.post(`api/app/yydUserTextbook/add/${textbookId}/${this.bjId}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								message: '获取成功',
								type: 'success'
							});
							this.init();
							this.fxFlag = false;
						}
					});
					this.$refs.ruleForm.resetFields();
				}
			});
		},
		kbenBtn(item) {
			console.log(item);
			this.withTextbookAuthorization(item, () => {
				this.$router.push({
					path: './tingliDec',
					query: {
						txt: item.title,
						tabFtxt: this.a,
						textbookId: item.textbookId,
						crumFlag: 1,
						tabFtxt: ['首页', '听力课本']
					}
				});
			});
		},
		/** 校验课本作答报告授权后再执行回调（GET .../checkTextbookAuthorization/{textbookId}，R<Boolean>） */
		withTextbookAuthorization(item, onOk) {
			const textbookId = item?.textbookId;
			if (!textbookId) {
				this.$message.warning('缺少课本信息');
				return;
			}
			const set = this.$loading(this.$pre);
			this.$http
				.get(`api/app/yydAnswerExam/checkTextbookAuthorization/${textbookId}`)
				.then((res) => {
					set.close();
					if (res.code !== 200 && res.code !== 0) {
						return;
					}
					if (res.data === true) {
						onOk();
					} else {
						this.$message.warning('课本已到期，请联系辅教员');
					}
				})
				.catch(() => {
					set.close();
				});
		},
		decFn(item) {
			this.withTextbookAuthorization(item, () => {
				this.$emit('ctkbFn', item.userTextbookId);
				this.$emit('ztsFn', item.textbookId);
				this.$emit('fhBtn', 'kebenDec');
			});
		},
		ctFn(item) {
			this.withTextbookAuthorization(item, () => {
				this.$emit('ctkbFn', item.userTextbookId);
				this.$emit('ctFn', item.textbookId);
				this.$emit('fhBtn', 'cuotiFb');
			});
		},
		reportFn(item) {
			this.withTextbookAuthorization(item, () => {
				this.$emit('ctkbFn', item.userTextbookId);
				this.$emit('ztsFn', item.textbookId);
				this.$emit('fhBtn', 'textbookReport');
			});
		},
		delQbFn() {
			if (this.multipleSelection.length) {
				let str = '';
				let strName = '';
				for (let item of this.multipleSelection) {
					str += item.textbookId + ',';
					strName += item.title + ',';
				}
				this.$confirm(`是否删除${strName.substring(0, strName.length - 1)}?`, '提示', {
					confirmButtonText: '确认',
					confirmButtonClass: 'delBtns',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						console.log(str);
						let set = this.$loading(this.$pre);
						this.$http.delete(`api/app/yydUserTextbook/remove/${str.substring(0, str.length - 1)}/${this.bjId}`).then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.init();
							}
						});
					})
					.catch(() => {});
			} else {
				this.$message({
					message: '请选择班级成员',
					type: 'warning'
				});
			}
			console.log(this.multipleSelection);
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		checkSelectable(row) {
			return true;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		init() {
			this.$http.get('api/app/yydTextbook/mylist').then((res) => {
				if (res.code == 200) {
					this.perData = res.rows || [];
				}
			});
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydTextbook/userBooklist/${this.bjId}`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.tableData = res.rows || [];
				}
				console.log(res, 8888);
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.keBox {
	display: flex;
	justify-content: center;
	height: 20px;
	align-items: center;
	white-space: nowrap;
	div {
		cursor: pointer;
	}
	.ztIcon {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}
}
.reportEntry {
	color: #3377e6;
	font-size: 14px;
	margin-left: 10px;
	i {
		font-size: 16px;
		margin-right: 4px;
	}
}
.fxP {
	font-size: 14px;
	text-align: center;
	margin-bottom: 33px;
}
.cyBox {
	background: #ffffff;
	border-radius: 6px;
	.cyTop {
		height: 80px;
		padding: 0 21px 0 16px;
		display: flex;
		align-items: center;
		position: relative;
		justify-content: space-between;
		border-bottom: 1px solid #eeeff2;
		.cyDelBtn {
			width: 90px;
			height: 30px;
			background: rgba(247, 85, 45, 0.05);
			border: 1px solid #f7552d;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #f7552d;
			cursor: pointer;
			img {
				width: 14px;
				height: 14px;
				margin-right: 4px;
			}
		}
		.cyDelBtns {
			color: #fff;
			background: #1d7b3a;
			border: 1px solid #1d7b3a;
			img {
				width: 12px;
				height: 15px;
				margin-right: 4px;
			}
		}
	}
}
.imgs {
	width: 64px;
	height: 80px;
	background: #d8d8d8;
	border-radius: 4px;
}
.ispan {
	cursor: pointer;
}
.iconBox {
	display: flex;
	align-items: center;
	line-height: 1;
	img {
		width: 15px;
		height: 15px;
		margin-right: 4px;
		margin-top: -1px;
	}
}
.delBox {
	text-align: center;
	img {
		width: 70px;
		height: 70px;
		margin-bottom: 39px;
	}
	h2 {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 11px;
	}
	p {
		color: #9d9d9d;
		font-size: 16px;
	}
}
</style>
